export default "__VITE_ASSET__NThdL8su__";